import { render } from "./IVRReport.vue?vue&type=template&id=8783257a&scoped=true"
import script from "./IVRReport.vue?vue&type=script&lang=js"
export * from "./IVRReport.vue?vue&type=script&lang=js"

import "./IVRReport.vue?vue&type=style&index=0&id=8783257a&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8783257a"]])

export default __exports__